
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SideMenu',
  // setup() {
  //   console.log('SideMenuSetup');
  // },
})
